import { FlexAnchor, FlexAnchorProps, useModal } from '@wrisk/ui-components'
import React, { type FC, useCallback } from 'react'

import { HelpLinkIFrame } from './HelpLinkIFrame'

export const HelpFlexAnchor: FC<Omit<FlexAnchorProps, 'ref'>> = ({
  children,
  ...props
}) => {
  const modal = useModal()

  const iframeId = `${props.id}_iframe`

  const openModal = useCallback(
    () =>
      modal.show({
        content: <HelpLinkIFrame id={iframeId} src={props.href} />,
        variant: 'iframe',
      }),
    [modal, props.href, iframeId],
  )

  return (
    <FlexAnchor
      aria-controls={iframeId}
      aria-haspopup='dialog'
      role='button'
      {...props}
      onClick={openModal}
    >
      {children}
    </FlexAnchor>
  )
}
